// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2B8td","actions":"GroupTable_actions__NJvWx","deleteModalFooter":"GroupTable_deleteModalFooter__3oA2c"};